import { Capacitor } from '@capacitor/core'

const isNativeDevice = () => {
  try {
    if (Capacitor && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform()) {
      return true
    }
    const platform = Capacitor && typeof Capacitor.getPlatform === 'function'
      ? Capacitor.getPlatform()
      : 'web'
    return platform === 'android' || platform === 'ios'
  } catch (e) {
    return false
  }
}

export default isNativeDevice
